import requests from './Setup'
import { API_URL } from 'config/env'

const RESOURCE = `${API_URL}/Licensing`

const Licensing = {
  status: () => requests.get(`${RESOURCE}/Status`).then(r => r.data),
  payments: () => requests.get(`${RESOURCE}/Payments`).then(r => r.data),
  paymentMethods: () => requests.get(`${RESOURCE}/PaymentMethods`).then(r => r.data),
  initiatePayment: (paymentMethodId, returnUrl, cancelUrl) =>
    requests.post(`${RESOURCE}/Initiate`, { paymentMethodId, returnUrl, cancelUrl }).then(r => r.data),
  submitPayment: (form) => {
    const data = new FormData()
    data.append('amount', form.amount)
    data.append('currency', form.currency || 'USD')
    data.append('paymentMethod', form.paymentMethod)
    data.append('reference', form.reference)
    data.append('destinationAccount', form.destinationAccount)
    if (form.notes) data.append('notes', form.notes)
    if (form.receipt) data.append('receipt', form.receipt)
    return requests.post(`${RESOURCE}/Payment`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data)
  },
}

export default Licensing
